'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    checkbox: {
        position: 'relative',
        bottom: 2,
        padding: 0
    },
    uncheckedCheckbox: {
        fontSize: 15,
        color: '#E0E0E0'
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-org-unit-tree/styles/OUCheckbox.component.styles.js
// module id = 2205
// module chunks = 0